import { allReq } from "@/axiosfiles/axios-outh";

// actions part
export const actions = {
  // Actions without mutations and states

  GET_ONLY(undifined, url) {
    return allReq
      .get(url)
      .then(data => {
        return data;
      })
      .catch(err => {
        throw err;
      });
  },
  DELETE(undifined, { url, data }) {
    return allReq
      .delete(url, { data })
      .then(data => {
        return data;
      })
      .catch(err => {
        throw err;
      });
  },
  // eslint-disable-next-line
  FIND_BY_VALUE({ commit }, { url, query }) {
    let params = {};
    if (query) params = { ...query };
    return allReq
      .get(url, {
        params,
      })
      .then(data => {
        return data;
      })
      .catch(err => {
        throw err;
      });
  },
  // eslint-disable-next-line
  INSERT_ONLY({ commit }, { url, data }) {
    // return postReq(value.url, value.data);
    return allReq
      .post(url, data)
      .then(data => {
        return data;
      })
      .catch(err => {
        // console.log("error");
        throw err;
        // return err;
      });
  },
  UPDATE_ONLY(undifined, { url, data }) {
    // return postReq(value.url, value.data);
    return allReq
      .put(url, data)
      .then(val => {
        return val;
      })
      .catch(err => {
        // console.log("error");
        throw err;
        // return err;
      });
  },

  // Actions with mutations
  SelectAll({ commit }, obj) {
    // const { GetCashTypes } = getters;
    const { url, MutName } = obj;

    // if (url === "/cashTypes" && !GetCashTypes.length) return "req Exists";

    return new Promise((resolve, reject) => {
      allReq
        .get(url)
        .then(data => {
          resolve(200);
          // console.log(data);
          if (data.status == 200) commit(MutName, data.data);
        })
        .catch(error => {
          // console.log(error.response);
          reject(error);
        });
    });
  },
};
//gettes part
